
const IndonesiaHeader = () => {
  return (
    <div className="text-center mb-8 space-y-6">
      {/* Logo Section */}
      <div className="flex justify-center mb-6 animate-scale-in">
        <img 
          src="/lovable-uploads/52ecf367-6211-48aa-82c5-83c88558cc42.png" 
          alt="NEXX Logo" 
          className="h-16 md:h-20 w-auto"
        />
      </div>

      {/* Main Headline */}
      <h1 className="text-4xl md:text-6xl font-bold text-gray-900 animate-fade-in" style={{ animationDelay: '0.2s' }}>
        <span className="bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent">
          Solusi Internet AS
        </span>
        <br />
        <span className="text-2xl md:text-4xl mt-2 block">
          untuk Pengguna Indonesia 🇮🇩
        </span>
      </h1>

      {/* Subheadline */}
      <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: '0.4s' }}>
        <span className="font-semibold text-red-600">US Residential Proxies, VPN & Remote Desktops</span>
        <br />
        <span className="text-lg md:text-xl">Akses cepat, aman, dan terpercaya dari Indonesia</span>
      </p>

      {/* Value Props */}
      <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base animate-fade-in" style={{ animationDelay: '0.6s' }}>
        <div className="flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-md border border-red-100">
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
          <span className="font-medium">Koneksi Cepat • Fast Connection</span>
        </div>
        <div className="flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-md border border-red-100">
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
          <span className="font-medium">Dukungan 24/7 • 24/7 Support</span>
        </div>
        <div className="flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-md border border-red-100">
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
          <span className="font-medium">Harga Terjangkau • Affordable</span>
        </div>
      </div>
    </div>
  );
};

export default IndonesiaHeader;
